import { render, staticRenderFns } from "./SignCard.vue?vue&type=template&id=288a755a"
import script from "./SignCard.vue?vue&type=script&lang=js"
export * from "./SignCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports